import { render, staticRenderFns } from "./DevicesManagerPage.vue?vue&type=template&id=31a157fb&scoped=true"
import script from "./DevicesManagerPage.vue?vue&type=script&lang=js"
export * from "./DevicesManagerPage.vue?vue&type=script&lang=js"
import style0 from "./DevicesManagerPage.vue?vue&type=style&index=0&id=31a157fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a157fb",
  null
  
)

export default component.exports